<ul *ngIf="pager.pages && pager.pages.length" class="pagination">
  <li [ngClass]="{disabled:pager.currentPage === 1}">
    <a (click)="setPage(1)">Primero</a>
  </li>
  <li [ngClass]="{disabled:pager.currentPage === 1}">
    <a (click)="setPage(pager.currentPage - 1)">Anterior</a>
  </li>
  <li
    *ngFor="let page of pager.pages"
    [ngClass]="{active:pager.currentPage === page}"
  >
    <a (click)="setPage(page)">{{page}}</a>
  </li>
  <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
    <a (click)="setPage(pager.currentPage + 1)">Siguiente</a>
  </li>
  <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
    <a (click)="setPage(pager.totalPages)">Último</a>
  </li>
  <li>
    <a>Cantidad de registros: {{ allItemsCount }}</a>
  </li>
  <li *ngIf="selectedAmount">
    <a>Cantidad seleccionados: {{ selectedAmount }}</a>
  </li>
  <li *ngIf="info">
    <a> {{ info }}</a>
  </li>
  <li *ngIf="exportColumns.length > 0">
     <a (click)="exportToCsv()">⬇️</a>
  </li>
</ul>
